import { useCallback, useMemo, useState } from 'react'
import moment from 'moment-timezone'
import _ from 'lodash'

import {
  MRT_ToggleDensePaddingButton,
  MRT_ShowHideColumnsButton,
  MRT_ToggleFullScreenButton,
  MRT_ToggleFiltersButton,
  MRT_ToggleGlobalFilterButton
} from 'material-react-table'

import { Box, IconButton, Tooltip } from '@mui/material'
import SaveAltIcon from '@mui/icons-material/SaveAlt'
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined'

import MapPopup from '/components/passes/map-popup'
import StudioTable, { useStudioTable } from '/components/studio-table'

import DataExportDialog from "../data-export-dialog"
import excelExport from './scans-to-excel-event'

const ScanTable = ({ scans, loading, templateId, passId }) => {

  const [scan,setScan] = useState()
  const [mapOpen,setMapOpen] = useState(false)
  const [dataExportDialogOpen, setDataExportDialogOpen] = useState(false)

  const openMap = useCallback(scanRecord => {
    setScan(scanRecord)
    setMapOpen(true)
  }, [])

  const columns = useMemo(() => [
    {
      id: 'timestamp',
      accessorFn: (originalRow) => moment(originalRow.timestamp, "YYYYMMDDHHmmss"),
      header: 'Scanned',
      Cell: ({ cell }) => cell.getValue().format("DD MMM YYYY HH:mm"),
      filterVariant: 'date-range',
      sortingFn: 'datetime',
      size: 180,
      Footer: () => "Totals"
    },
    {
      accessorKey: 'action',
      header: 'Action',
      filterVariant: 'autocomplete',
      size: 200,
    },
    {
      accessorKey: 'error',
      header: 'Error',
      filterVariant: 'autocomplete',
      size: 200,
    },
    {
      accessorKey: 'username',
      header: 'Scanned By',
      filterVariant: 'autocomplete',
      size: 200,
    },
    {
      accessorKey: 'note',
      header: 'Note',
      filterVariant: 'autocomplete',
      size: 200,
    },
    {
      id: 'position',
      accessorFn: (originalRow) => originalRow,
      header: 'Scan Location',
      filterVariant: 'autocomplete',
      size: 400,
      Cell: ({ cell }) => {
        const row = cell.getValue()
        return row.position ? <div className='link' onClick={() => openMap(row)}><RoomOutlinedIcon className='mr-5' />{row.position.x},{row.position.y}</div> : null
      }
    },
  ], [openMap])

  const table = useStudioTable({
    tableKey: 'scan-history-event',
    columns,
    data: scans,
    state: {
      isLoading: loading
    },
    initialState: { showColumnFilters: false },
    enablePagination: false,
    enableBottomToolbar: false,
    enableRowSelection: false,
    enableMultiRowSelection: false,
    enableRowActions: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    positionToolbarAlertBanner: "none",
    getRowId: (originalRow) => originalRow.id,
    renderToolbarInternalActions: ({ table: tableInstance }) => (
      <Box>
        <MRT_ToggleGlobalFilterButton table={tableInstance} />
        <MRT_ToggleFiltersButton table={tableInstance} />
        <MRT_ShowHideColumnsButton table={tableInstance} />
        <MRT_ToggleDensePaddingButton table={tableInstance} />
        <MRT_ToggleFullScreenButton table={tableInstance} />
        <Tooltip title="Export"><IconButton onClick={() => setDataExportDialogOpen(true)}><SaveAltIcon /></IconButton></Tooltip>
      </Box>
    ),
  })

  return (
    <>
      <MapPopup scan={scan} open={mapOpen} setOpen={setMapOpen}/>
      <DataExportDialog open={dataExportDialogOpen} setOpen={setDataExportDialogOpen} fileName={`${templateId}-(${passId})-scan-history`} data={scans} excelExport={excelExport} table={table} />
      <StudioTable table={table} />
    </>
  )

}

export default ScanTable
